import React, { useState } from 'react';
import { CloseButton } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEditWipWorkFlowMutation, useEditClosedWorkFlowMutation } from "../../..//../../Services/campaign/CampaignMapping";

interface IProps {
  closeModal: () => void;
  selectedWip: any; // Consider defining a more specific type here.
  refetch: () => any;
  theTeams: any

}

const EditWipModal: React.FC<IProps> = ({ closeModal, selectedWip, refetch, theTeams }) => {
  const initialValues = {
    name: selectedWip.status.status || '',
  };
  const [triggeerEditWip] = useEditWipWorkFlowMutation();
  const [triggeerEditClosed] = useEditClosedWorkFlowMutation();
  const validationSchema = Yup.object({
    name: Yup.string().required('Status Title is required'),
  });
  const [selectedTeam, setSelectedTeam] = useState<number>(selectedWip?.status?.assignment_team?.id || null);

  console.log(selectedWip)
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const payload = {
        assignment_team: selectedTeam,
        campaign_name: selectedWip?.status?.id,
        status: values.name,
        visibility_team: selectedWip?.status?.visibility_team?.id === undefined ? null : selectedWip?.status?.visibility_team?.id,
      };
     console.log(payload,"testing")
      try {
        // Pass the payload correctly to the API call
        if (selectedWip?.status_type === 'closed') {
          await triggeerEditClosed({ body: payload });
          await refetch();
          closeModal();
        } else {

          await triggeerEditWip({ body: payload });
          await refetch();
          closeModal();
        }
      } catch (error) {
        console.error('Error saving WIP:', error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  const handleTeamDropdownChange = (evt: any) => { setSelectedTeam(Number(evt.target.value)) }

  return (
    <div>
      <div className="text-end">
        <CloseButton onClick={closeModal} />
      </div>

      <form
        className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
        noValidate
        onSubmit={formik.handleSubmit}
      >

        <div className="row g-5 g-xl-8 mb-6">
          <div className="col-xl-6">
            <div className="d-flex flex-column">
              <label className="required">Add a stage title</label>
              <input
                id="name"
                name="name"
                type="text"
                className="form-control"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />

              {formik.touched.name && formik.errors.name && (
                <div className="fv-plugins-message-container text-danger">
                  <span role="alert">{formik.errors.name}</span>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-6">
            <label>Select team</label>
            <select
              className="form-select select2-hidden-accessible"
              name="assignment_team"
              onChange={handleTeamDropdownChange}
              value={selectedTeam}

            >
              <option value="">Select team</option>
              {theTeams && theTeams.map((theTeam) => (<option value={theTeam.id}>{theTeam.name}</option>))}
            </select>

          </div>
        </div>
        <div className="row g-5 g-xl-8 mb-6">
          {/*ticket name feed*/}
          <div className="col-xl-12">
            <div className="row row-cols-2">
              <div className="col"><input type="radio" name="assignmentType" value="individualassignment" id="indvassgn" className="form-check-input" /><label htmlFor="indvassgn" className="form-label ps-2">Individual Assignment</label></div>
              <div className="col"><input type="radio" name="assignmentType" value="roundrobin" id="roundrobin" className="form-check-input" /><label htmlFor="roundrobin" className="form-label ps-2">Round Robin</label></div>
              <div className="col"><input type="radio" name="assignmentType" value="activelogins" id="activelgn" className="form-check-input" /><label htmlFor="activelgn" className="form-label ps-2">Active Logins(RR)</label></div>
              <div className="col"><input type="radio" name="assignmentType" value="teamassignment" id="teamassgn" className="form-check-input" /><label htmlFor="teamassgn" className="form-label ps-2">Team Assignment</label></div>
            </div>
          </div>
        </div>

        <div className="text-end mt-6 mb-4">
          <button
            className={`btn btn-sm btn-primary`}
            type="submit"
            disabled={formik.isSubmitting}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditWipModal;